import React, { useContext, useEffect, useState } from "react";
import "./RamlC.css";
import { Container, Row, Col } from "react-bootstrap";
import RamlSection from "../ramlsection/RamlSection";
import { useForm, Controller } from "react-hook-form";
import ModalFull from "../../utils/Modals/ModalFull";
import { MainContext } from "../../contexts/MainContext";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import ApiGetX2 from "../../utils/ApiServicesX/ApiGetX2";
import DateFormat from "../../utils/DateFormat";

export default function RamlC({ classs, stat, flagg, chF, chG, chH, chJ, setZNameState }) {
  let { setLotNameCon, setTitleIdCon, setQuestionIdCon, userId, titleTopics, setTitleTopics, allQuestions, setAllQuestions, setAllSource, dateZayeche } = useContext(MainContext);
  const navigate = useNavigate();
  const [ok, setOk] = useState(false);
  const [allUserShaps, setAllUserShaps] = useState([false]);
  const [question, setQuestion] = useState([]);
  const [titleId, setTitleId] = useState("");
  const [questionId, setQuestionId] = useState("");
  const sortedTitle = titleTopics?.sort((a, b) => a.order - b.order);
  const sortedQuestion = question?.sort((a, b) => a.order - b.order);

  const {
    control,
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
    },
  });
  const selectedTitle = watch("title");

  const handleRegistration = (data) => {
    console.log(data);
    setOk(true);
    setZNameState(true);
    setLotNameCon(data.name);
    setTitleIdCon(data.title);
    setQuestionIdCon(data.question);
  };

  let stat2 = stat;
  let flagg2 = flagg;

  useEffect(() => {
    ApiGetX2("/api/AgTopics/getTopic?type=1", setTitleTopics);
  }, []);
  useEffect(() => {
    setTitleId(selectedTitle);
  }, [selectedTitle]);

  useEffect(() => {
    setQuestionId("");
    if (titleId) {
      const url = `/api/AgTopics/getQuestionByTopicID?tId=${titleId}`;
      ApiGetX2(url, setQuestion);
    } else {
      setQuestion([]);
    }
  }, [titleId]);
  useEffect(() => {
    const url = `/api/AgMain/getUserShapeByUserID?userId=${userId}`;
    ApiGetX2(url, setAllUserShaps);
    const url2 = `/api/AgTopics/getQuestion`;
    ApiGetX2(url2, setAllQuestions);
    const url3 = `/api/AgSource/getAllSources`;
    ApiGetX2(url3, setAllSource);
  }, []);
  return (
    <Container>
      <Row>
        <Col></Col>
        <Col xs={12}>
          {!ok && stat == 1 ? (
            <Form onSubmit={handleSubmit(handleRegistration)} className="centercc mt-5 " style={{ width: "320px", height: "400px" }}>
              <Form.Group className="mb-3 raml-ZName" controlId="formname">
                <Form.Control
                  type="text"
                  placeholder="نام (اختیاری) ..."
                  {...register(
                    "name"
                    //   , {
                    //   required: " وارد کردن نام الزامی است ...",
                    // }
                  )}
                  // isInvalid={!!errors.name}
                />
                <Form.Control.Feedback type="invalid">{/* {errors.phone?.message} */}</Form.Control.Feedback>
              </Form.Group>

              <Form.Select
                aria-label="Default select example"
                {...register("title", {
                  onChange: (e) => {
                    setTitleId(e.target.value);
                    reset({
                      question: "",
                    });
                  },
                })}
              >
                <option value="">انتخاب موضوع (اختیاری)...</option>
                {titleTopics.length !== 0 &&
                  sortedTitle?.map((item) => (
                    <option value={item.id} key={item.id}>
                      {item.description}
                    </option>
                  ))}
              </Form.Select>

              <Form.Select
                aria-label="Default select example"
                {...register("question", {
                  onChange: (e) => {
                    setQuestionId(e.target.value);
                  },
                })}
              >
                <option value="">انتخاب سوال (اختیاری)...</option>
                {question.length !== 0 &&
                  sortedQuestion?.map((item) => (
                    <option value={item.id} key={item.id}>
                      {item.description}
                    </option>
                  ))}
              </Form.Select>

              <Form.Select aria-label="Default select example" {...register("circle")}>
                <option>انتخاب دایره (اختیاری)...</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </Form.Select>

              <Link className={"linkBtn"} to="/selectraml">
                {" "}
                ادعیه{" "}
              </Link>
              <button
                className={"linkBtn"}
                type="submit"
                // to="/ramlpic"
              >
                {" "}
                تایید
              </button>

              <ModalFull breakpoint={true} text={"انتخاب زاییچه های ذخیره شده"}>
                <div className="container">
                  <div className="row">
                    <div className="col-md-8">
                      <table className="table table-striped select-userShape-table boxSh">
                        <thead>
                          <tr key="">
                            <th>ردیف</th>
                            <th> نام زایچه /تاریخ ایجاد </th>
                            <th>موضوع</th>
                            <th>سوال</th>
                            <th>ویرایش /حذف</th>
                          </tr>
                        </thead>

                        <tbody>
                          {allUserShaps.length != 0 &&
                            allUserShaps.map((item, index) => (
                              <tr key="">
                                <td>{index + 1}</td>
                                <td>
                                  {item.lotName}
                                  <br />
                                  <DateFormat dateString={item.createDate} />
                                </td>
                                <td>{titleTopics?.filter((filter) => filter.id == item.titleID)[0]?.description} </td>
                                <td>{allQuestions?.filter((filter) => filter.id == item.agQuestionId)[0]?.description}</td>
                                <td>
                                  <button className="btn btn-info rvhide select-editbut">📝</button>
                                  <span className="rvshow"> 📝</span>
                                  <button className="btn btn-danger rvhide select-delebut">✖️</button>

                                  <span className="rvshow"> ✖️</span>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </ModalFull>
            </Form>
          ) : (
            <div className={classs}>
              <span className="ramlc-span">{stat}</span>
              <RamlSection stat3={stat2} num={1} chF2={chF} flaggg={flagg2}></RamlSection>
              <RamlSection stat3={stat2} num={2} chG2={chG}></RamlSection>
              <RamlSection stat3={stat2} num={3} chH2={chH}></RamlSection>
              <RamlSection stat3={stat2} num={4} chJ2={chJ}></RamlSection>
            </div>
          )}
        </Col>
        <Col></Col>
      </Row>
    </Container>
  );
}
